import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";

// Import Bootstrap
// import { Nav, Container, Row, Col }  from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.css";

// Import Custom CSS
import "./App.css";

// Import from react-router-dom
import {
  BrowserRouter as Router, Routes,
  Route, Link
} from "react-router-dom";

import axios from 'axios';
import CNavbar from './Components/Navbar';
import PatientVisits from './Components/PatientVisits'; // Import the PatientVisits component
import ListofDoctors from './Components/ListofDoctors';
import EditPatientInfo from './Components/Edit/EditPatientInfo';
import EditPatientSymptoms from './Components/Edit/EditPatientSymptoms';
import EditPatientHistory from './Components/Edit/EditPatientHistory';
import EditPatientCI from './Components/Edit/EditPatientCI';
import EditPatientAnyavyadhi from './Components/Edit/EditPatientAnyavyadhi';
import EditPatientKulawrutta from './Components/Edit/EditPatientKulawrutta';
import EditPatientTapasyana from './Components/Edit/EditPatientTapasanya';
import EditPatientArtawawrutta from './Components/Edit/EditPatientArtawawrutta';
import EditPatientDiagnosis from './Components/Edit/EditPatientDiagnosis';
import EditPatientTreatment from './Components/Edit/EditPatientTreatment';
import EditPatientNextVisit from './Components/Edit/EditPatientNextVisit';
import EditPatientPaymentForm from './Components/Edit/EditPatientPaymentForm';
import AddPatientInfo from './Components/Add/AddPatientInfo';
import AddClinic from './Components/Add/AddClinic';
//import DoctorManagement from './Components/DoctorManagement';
import AddDoctor from './Components/Add/AddDoctor';
//import AddNewCase from './Components/Add/AddNewCase';
//import CONFIG from './config';
import EditMandaliInfo from './Components/Edit/EditMandaliInfo';
// import CheckToken from './Components/Mandali/CheckToken';
import CheckForm from './Components/Mandali/CheckForm';
import SelectPatientAndCases from './Components/SelectPatientAndCases';
// import Logout from './Components/Logout';
import AuthProvider from './context/AuthProvider';
import MyProfileInfo from './Components/MyProfileInfo';
import { PatientProvider } from './context/PatientContext';
import AddNewCase from './Components/Add/AddNewCase';
import SelectedPatientDetails from './Components/SelectedPatientDetails';
import PatientLayout from "./Components/PatientLayout";
import MyCalendarView from './Components/MyCalendarView';
import AddAttendant from './Components/Add/AddAttendant';
import PatientPaymentReport from './Components/Reports/PatientPaymentReport';

const App = () => {

  return (
    <Router>      
      <PatientProvider>
      <AuthProvider>
      <div className="App">
        <CNavbar />
        <Routes>

          {/* Static or global routes */}
          <Route path="/" element={<CheckForm />} />
          {/* <Route path="/addpatient" element={<AddPatientInfo />} /> */}
          <Route path="/getmandaliinfo" element={<MyProfileInfo />} />
          <Route path="/edit-doctor/:id" element={<EditMandaliInfo />} />
          <Route path="/doctorslist" element={<ListofDoctors />} />
          <Route path="/add-doctor" element={<AddDoctor />} />
          <Route path="/add-Attendant" element={<AddAttendant />} />
          <Route path="/add-clinic" element={<AddClinic />} />
          <Route path="/calendar" element={<MyCalendarView />} />
          <Route path="/patientlist" element={<SelectPatientAndCases />} />
          <Route path="/reports/payments" element={<PatientPaymentReport />} />
          <Route path="/patient/:patientId" element={<SelectedPatientDetails />} />
          <Route path="/visits/:patientId/:caseId" element={<PatientVisits />} />
          <Route path="/visits/:patientId/:caseId/addcase" element={<AddNewCase />} />

          <Route path="/addpatient" element={<PatientLayout />}>
            <Route index element={<AddPatientInfo  />} />
            <Route path="symptoms" element={<EditPatientSymptoms />} />
            <Route path="history" element={<EditPatientHistory />} />
            <Route path="ci" element={<EditPatientCI />} />
            <Route path="anyavyadhi" element={<EditPatientAnyavyadhi />} />
            <Route path="kulawrutta" element={<EditPatientKulawrutta />} />
            <Route path="tapasanya" element={<EditPatientTapasyana />} />
            <Route path="artawawrutta" element={<EditPatientArtawawrutta />} />
            <Route path="diagnosis" element={<EditPatientDiagnosis />} />
            <Route path="treatment" element={<EditPatientTreatment />} />
            <Route path="payment" element={<EditPatientPaymentForm/>}/>
            <Route path="nextvisit" element={<EditPatientNextVisit />} />
          </Route>
          {/* 👇 Dynamic layout route for visit-related forms */}
          <Route path = "/visits/:patientId/:caseId/:visitId/" element={<PatientLayout />}>
            <Route index element={<EditPatientInfo />} /> {/* Default tab */}
            <Route path="symptoms" element={<EditPatientSymptoms />} />
            <Route path="history" element={<EditPatientHistory />} />
            <Route path="ci" element={<EditPatientCI />} />
            <Route path="anyavyadhi" element={<EditPatientAnyavyadhi />} />
            <Route path="kulawrutta" element={<EditPatientKulawrutta />} />
            <Route path="tapasanya" element={<EditPatientTapasyana />} />
            <Route path="artawawrutta" element={<EditPatientArtawawrutta />} />
            <Route path="diagnosis" element={<EditPatientDiagnosis />} />
            <Route path="treatment" element={<EditPatientTreatment />} />
            <Route path="payment" element={<EditPatientPaymentForm/>}/>
            <Route path="nextvisit" element={<EditPatientNextVisit />} />
          </Route>


        </Routes>

      </div>
    </AuthProvider>
    </PatientProvider>
    </Router>

  );
};


const PatientSearchBox = ({ onSearch }) => {


  const [searchTerm, setSearchTerm] = useState('');


  const clientSearch = () => {
    console.log(searchTerm);
    onSearch(searchTerm);
  };

  return (
    <div>
      <input
        type="text"
        placeholder="Search patients by name"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <button onClick={clientSearch}>Search</button>
    </div>
  );
};

const PatientCaseSelect = ({ patientId, caseId }) => {

  console.log(patientId);
  console.log(caseId);
  const navigate = useNavigate();
  const location = useLocation();

  const handleCaseSelect = (patientId, caseId) => {

    // const navigate = useNavigate();
    navigate(`/visits/${patientId}/${caseId}`, { state: location.state });

  };

  return (

    <div>
      <button onClick={() => handleCaseSelect(patientId, caseId)}>View Visits</button>
    </div>

  );

};

export default App;
